
















































import { Component, Vue } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'
import SelectLayout from '@/components/gambling/SelectLayout.vue'
import { openAccount } from '@/utils/gamblingHelpers'
import Account from '@/components/gambling/AccountComponents/Account.vue'
import AccountBalance from '@/components/gambling/AccountBalance.vue'

@Component({
  components: {
    SelectLayout,
    Account,
    AccountBalance
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any) => gamblingContext.isAuthenticated,
      username: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout
    })
  }
})

export default class HeaderTwo extends Vue {
  @Action('logout') logout: any
  @Action('setSidebar') setSidebar: any
  @Mutation('setAccountType') setAccountType: any

  openAccountModal: boolean = false
  $routeChange!: any
  $smallScreen!: boolean
  $cashierConfigs!: any

  openAccount (type: string) {
    openAccount(type, this)
  }

  logoutMethod () {
    this.$routeChange('/gambling')
    this.logout()
  }

  toHomePage () {
    this.setAccountType('account')
    this.$cashierConfigs('bankingPageFlow', {
      showHeader: !this.$smallScreen
    })
    this.$routeChange('/gambling')
  }
}
